import React from "react";
import LeftArrowIconSvg from "static/images/left-arrow.svg";

enum ArrowOrientationType {
  Left,
  Right,
}

interface Props {
  orientation?: ArrowOrientationType;
  text?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
}

export default function BackIcon({
  orientation,
  text,
  onClick,
}: Props): React.ReactElement {
  const getIconSrc = () => {
    return orientation === ArrowOrientationType.Left ? LeftArrowIconSvg : "";
  };

  return (
    <div className="flex cursor-pointer" onClick={onClick}>
      <img src={getIconSrc()} alt={"back-arrow"} className="mr-2" />
      {text}
    </div>
  );
}

BackIcon.defaultProps = {
  orientation: ArrowOrientationType.Left,
  text: "",
};
